import Tasks from "./components/Tasks";

export default Tasks;
